import React from "react";
import PropTypes from "prop-types";
// Material imports
import withStyles from "@mui/styles/withStyles";
import Typography from "@mui/material/Typography";
// Limitless imports
import { getLastAmbassadorDialogue } from "@limitless/common/utils";
import { withi18n } from "../../hocs/i18n";
import UserAvatar from "../../user-avatar/UserAvatar";
import RatingSystem, { SEVEN_SMILEY_RATING_SYSTEM } from "../csat-footer/RatingSystem";
import CustomerButton from "../../customer-button/CustomerButton";
import { EXPERT_FEEDBACK, FURTHER_CONTACT } from "../../../utils";
const SEVEN_FACES_DESCRIPTIONS = ["Extremely dissatisfied", "Moderately dissatisfied", "Slightly dissatisfied", "Neither satisfied nor dissatisfied", "Slightly satisfied", "Moderately satisfied", "Extremely satisfied"];
const CSATScreen = ({
  logger,
  t,
  classes,
  onSubmitCSATScore,
  message,
  containerClass,
  isMobileDevice
}) => {
  var _message$custClientSc, _message$custClientSc2;
  const [score, setScore] = React.useState(-1);
  const [disableButton, setDisableButton] = React.useState(false);
  const [showNext] = React.useState(message.customerScore || message.custScoreScheme.defaultScore);
  const [hoverText, setHoverText] = React.useState(null);
  const isRTL = document.documentElement.getAttribute("dir") === "rtl";
  const {
    hasSingleExpert,
    lastDialogue: {
      author = ""
    },
    thumbnail
  } = getLastAmbassadorDialogue(message);
  logger.debug("CSATScreen: ", message);
  const handleRate = score => {
    if (!showNext) {
      onSubmitCSATScore(score);
    } else {
      setScore(score);
    }
  };
  const handleNext = () => {
    setDisableButton(true);
    onSubmitCSATScore(score);
  };
  const handleHoverIcons = score => {
    setHoverText(SEVEN_FACES_DESCRIPTIONS[score - 1]);
  };
  const formatTextForRTL = (text, isRTL, ...variables) => isRTL ? `\u202A${t(text, ...variables)}\u202C` : t(text, ...variables);
  const is7FacesSchema = React.useMemo(() => {
    var _message$custScoreSch;
    return ((_message$custScoreSch = message.custScoreScheme) === null || _message$custScoreSch === void 0 ? void 0 : _message$custScoreSch.name) === SEVEN_SMILEY_RATING_SYSTEM;
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: `${containerClass} ${!hasSingleExpert || !thumbnail ? classes.center : ""} ${classes.cstScreen}`
  }, /*#__PURE__*/React.createElement("div", {
    className: `${is7FacesSchema ? classes.titleContainer : ""}`
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2",
    classes: {
      subtitle2: classes.heading
    },
    component: "div"
  }, formatTextForRTL(hoverText ? hoverText : hasSingleExpert ? "How would you rate {0}?" : "How was your experience?", isRTL, author))), /*#__PURE__*/React.createElement("div", {
    className: classes.ratingWrapper
  }, hasSingleExpert && thumbnail && ((_message$custClientSc = message.custClientScoreScheme) === null || _message$custClientSc === void 0 ? void 0 : _message$custClientSc.name) !== EXPERT_FEEDBACK && ((_message$custClientSc2 = message.custClientScoreScheme) === null || _message$custClientSc2 === void 0 ? void 0 : _message$custClientSc2.name) !== FURTHER_CONTACT && /*#__PURE__*/React.createElement("div", {
    className: classes.avatarContainer
  }, /*#__PURE__*/React.createElement(UserAvatar, {
    thumbnail: thumbnail,
    author: author,
    avatarClassName: classes.avatar
  })), /*#__PURE__*/React.createElement(RatingSystem, {
    onClick: handleRate,
    onHover: is7FacesSchema ? handleHoverIcons : null,
    message: message,
    disabled: false,
    isMobileDevice: isMobileDevice
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.nextButtonContainer
  }, showNext ? /*#__PURE__*/React.createElement(CustomerButton, {
    style: {
      width: 100
    },
    onClick: handleNext,
    component: "div",
    id: "nextButton",
    disabled: disableButton
  }, "Next") : /*#__PURE__*/React.createElement(React.Fragment, null)));
};
export const ratingStyles = theme => ({
  heading: {
    textAlign: "center"
  },
  ratingWrapper: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    paddingTop: 8
  },
  avatarContainer: {
    marginTop: 8,
    marginBottom: 16
  },
  nextButtonContainer: {
    display: "flex",
    justifyContent: "center",
    marginTop: 8
  },
  avatar: {
    width: 50,
    height: 50
  },
  center: {
    justifyContent: "center"
  },
  textField: {
    width: "100%"
  },
  root: {
    padding: "4px"
  },
  focused: {
    "&$focused $notchedOutline": {
      borderColor: theme.palette.text.secondary,
      borderWidth: 1
    }
  },
  notchedOutline: {},
  titleContainer: {
    height: 50,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    overflow: "auto"
  }
});
export default withStyles(ratingStyles)(withi18n(CSATScreen, "CSATScreen"));
CSATScreen.propTypes = {
  classes: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  message: PropTypes.object.isRequired,
  onSubmitCSATScore: PropTypes.func.isRequired,
  logger: PropTypes.object.isRequired,
  containerClass: PropTypes.string.isRequired,
  isMobileDevice: PropTypes.bool.isRequired
};